import { isValidPhoneNumber } from "libphonenumber-js/min";
import * as Yup from "yup";
// Validation schema for each guest
const guestEntrySchema = Yup.object()
  .shape({
    firstname: Yup.string().nullable(),
    mobile: Yup.string().nullable(),
    country_code: Yup.string().nullable(),
  })
  .test(
    "name-or-mobile-required",
    "Either both Name and mobile should be filled, or both should be empty.",
    function (value) {
      const { firstname, mobile } = value || {};
      const nameProvided = firstname?.trim().length > 0;
      const mobileProvided = mobile?.trim().length > 0;
      return (
        (!nameProvided && !mobileProvided) || (nameProvided && mobileProvided)
      );
    }
  );

// Main form schema
export const audienceValidationSchema = Yup.object().shape({
  _id: Yup.string(),
  firstname: Yup.string().required("Firstname is mandatory"),
  lastname: Yup.string().required("Lastname is mandatory"),
  country_code: Yup.string().required("Country Code is mandatory"),
  mobile: Yup.number()
    // .min(1000000000, "Please enter a valid mobile no.")
    .required("Mobile is mandatory")
    .test(
      "is-valid-phone",
      "Invalid mobile number",
      function (value) {
        const { country_code } = this.parent;
        if (!country_code || !value) return false;

        const phone = `${country_code}${value}`;
        return isValidPhoneNumber(phone);
      }
    ),
  gender: Yup.string(),
  city: Yup.string().required("City is mandatory"),
  hear_about: Yup.string(),
  email: Yup.string().email("Please enter valid email address"),
  guests: Yup.array()
    .of(guestEntrySchema)
    .max(4, "Guests cannot be more than 4")
    .notRequired(),
});

export const groupaudienceValidationSchema = Yup.object().shape({
  _id: Yup.string(),
  firstname: Yup.string().required("Firstname is mandatory"),
  lastname: Yup.string().required("Lastname is mandatory"),
  country_code: Yup.string().required("Country Code is mandatory"),
  mobile: Yup.number()
    // .min(1000000000, "Please enter a valid mobile no.")
    .required("Mobile is mandatory")
    .test(
      "is-valid-phone",
      "Invalid mobile number",
      function (value) {
        const { country_code } = this.parent;
        if (!country_code || !value) return false;

        const phone = `${country_code}${value}`;
        return isValidPhoneNumber(phone);
      }
    ),
  gender: Yup.string(),
  city: Yup.string().required("City is mandatory"),
  hear_about: Yup.string(),
  email: Yup.string().email("Please enter valid email address"),
  organization_name: Yup.string().required("Organization name is mandatory"),
  description: Yup.string().required("Description is mandatory"),
  no_of_group_guest: Yup.number().required("Number of People is mandatory")
});

